import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router-dom';

import { setWaitCampaign } from '../../_redux/actions/campaign';

import { ReactComponent as Cursos } from '../../img/cursos.svg';

import { ReactComponent as Cinema } from '../../img/cinema.svg';
import { ReactComponent as Eletrodomesticos } from '../../img/eletrodomesticos.svg';
import LogoHeaderDesk from '../../img/logo-yalo-horizontal.png';
import LogoHeader from '../../img/logoyaloverde.png.png';
import { ReactComponent as LogoDrConsulta } from '../../img/dr-consulta2.svg';
import logoConsulta from '../../img/dr-consulta2.svg';
import './index.scss';
import farmacias2 from '../../img/farmacias.png';
import DrogasilDrogaRaia from '../../img/drogasil--drogaraia.png';
import SmartFit from '../../img/smartfit.png';
import stores from '../../utils/stores';
import WhatsAppBtn from '../../Components/WhatsAppBtn';
import Brasiladm from '../../img/LOGO-BRASIL-ADM.png';

import Loading from '../../Components/Loading';
import ModalCorona from '../../Components/ModalCorona';
import ProductTable from '../../Components/ProductsTable';

import {
	benefitsTipsIndividual,
	benefitsIndividual,
	benefitsTableIndividual,
	plansIndividual
} from '../../utils/stores-plans';
import { PageView, initGA } from '../../Components/Tracking';

import { campaignUtils } from '../../utils';

class Home2 extends Component {
	componentWillMount() {
		if (campaignUtils.checkExist(this.props.location.search)) {
			let campaignData = campaignUtils.getData();
			this.props.setWaitCampaign(campaignData);
		}
	}
	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;

			$('.drc-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true
			});
			$('.discounts-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 992,
						settings: 'unslick'
					}
				]
			});
			$('[data-toggle="tooltip"]').tooltip();
		}

		initGA('UA-120298096-1');
		PageView('/loja/yalo');
		sessionStorage.setItem('store', stores.brasiladmindividual);
	}
	render() {
		const planPrice = {
			'YALO Individual': '35,90'
		};
		return (
			<div className='page-wrapper'>
				<Loading></Loading>
				<div className='container-fluid'>
					<div className='row visible-xs visible-sm header'>
						<div className='header-bar'>
							<img src={LogoHeader} alt='' width={90} />
						</div>
					</div>
					<div className='row visible-md visible-lg header-desk'>
						<div className='header-bar'>
							<img src={LogoHeaderDesk} alt='' width={100} />
						</div>
					</div>

					<div className='row'>
						<div className='col-xs-12 col-md-12 landing'>
							<section className='section featured'>
								<div className='container-fluid'>
									<div className='row visible-xs visible-sm sec-pad'>
										<div className='col-12 text-center'>
											<img
												src={Brasiladm}
												style={{ marginTop: '10px', marginBottom: '15px' }}
												alt=''
												height={70}
												width={275}
											/>
										</div>
										<div className='col-12'>
											<h1 className='f-bold ass'>A assinatura da saúde!</h1>

											<h2>
												O programa de assinatura
												<br />
												do
												<span className='logo-drconsultawhite'>
													{' '}
													dr<span>.</span>consulta
												</span>
												, agora <br /> com consultas online.
											</h2>
										</div>
									</div>
									<div className='row'>
										<div className='col-xs-12 col-md-8 center-mobile hidden-sm hidden-xs'>
											<div className='col-12 text-left'>
												<img
													src={Brasiladm}
													height={100}
													width={450}
													alt=''
													style={{ marginTop: '55px', marginBottom: '0' }}
												/>
											</div>
											<h1 className='f-bold'>
												<br />A assinatura da saúde!
											</h1>
											<h2>
												O programa de assinatura
												<br />
												do
												<span className='logo-drconsultawhite'>
													{' '}
													dr<span>.</span>consulta
												</span>
												, agora <br /> com consultas online.
											</h2>
										</div>
									</div>
									{/* Inicio Slider */}
									<div className='row visible-xs visible-sm'>
										<div className='col-xs-offset-1 col-xs-10'>
											<div className='drc-carousel'>
												<div className='drc-box-new head'>
													<div className='drc-box--content'>
														<h2 className='text-center'>
															<img
																src={logoConsulta}
																className='imgbox'
																alt=''
															/>
															<br />
															Consulta presenciais e online por apenas{' '}
															<strong className='f-black'>R$ 40</strong>
															<br />
															com retorno gratuito em até 30 dias
															<br /> e<strong className='f-black'>
																{' '}
																20%
															</strong>{' '}
															de desconto em exames.
														</h2>
													</div>
												</div>
												<div className='drc-box-new head'>
													<div className='drc-box--content'>
														<h2 className='text-center'>
															<img
																src={DrogasilDrogaRaia}
																className='imgbox'
																alt=''
															/>{' '}
															<br />
															<strong className='f-black'>15%</strong> de
															desconto <br />
															em medicamentos tarjados genéricos e de marca.
														</h2>
													</div>
												</div>
												<div className='drc-box-new head'>
													<div className='drc-box--content'>
														<h2>
															<h2
																className='club-descontos'
																style={{ fontSize: '24px' }}>
																Clube de Descontos
															</h2>
															Desconto em mais de{' '}
															<strong className='f-black'>200</strong> lojas, de
															diversos segmentos, como cinemas, eletrônicos,
															lazer, entre outros. Seguro de vida e sorteio
															mensais.
														</h2>
													</div>
												</div>
											</div>
										</div>
									</div>
									{/* Fim Slider */}

									<div className='row visible-md visible-lg'>
										<div className='col-xs-12 col-md-4'>
											<div className='drc-box'>
												<div className='drc-box--content'>
													<h2 className='text-center'>
														<LogoDrConsulta
															alt='dr.consulta'
															className='svg-consulta'></LogoDrConsulta>
														<br />
														Consulta presenciais e online por apenas{' '}
														<strong className='f-black'>R$ 40</strong> com
														retorno gratuito em até 30 dias e
														<strong className='f-black'> 20%</strong> de
														desconto em exames.
													</h2>
												</div>
											</div>
										</div>
										<div className='col-xs-12 col-md-4'>
											<div className='drc-box'>
												<div className='drc-box--content'>
													<h2 className='text-center'>
														<img
															src={DrogasilDrogaRaia}
															className='imgbox'
															alt=''
														/>{' '}
														<br />
														<strong className='f-black'>15%</strong> de desconto{' '}
														<br />
														em medicamentos tarjados genéricos e de marca.
													</h2>
												</div>
											</div>
										</div>
										<div className='col-xs-12 col-md-4'>
											<div className='drc-box'>
												<div className='drc-box--content'>
													<h2>
														<h2
															className='club-descontos'
															style={{ fontSize: '24px' }}>
															Clube de Descontos
														</h2>
														{/* <img src={SmartFit} className='imgbox' alt='' />{' '} */}
														<br />
														Desconto em mais de{' '}
														<strong className='f-black'>200</strong> lojas, de
														diversos segmentos, como cinemas, eletrônicos,
														lazer, entre outros. Seguro de vida e sorteio
														mensais.
													</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							{/* Inicio Slider */}
							{/* <div className='row visible-xs visible-sm'>
								<div className='col-xs-offset-1 col-xs-10'>
									<div className='drc-carousel'>
										<div className='discount-box'>
											<div className='discount-box-content'>
												<h3 className='desconto-economize'>60%</h3>
												<p className='text-economize'>
													de desconto em medicamentos genéricos tarjados
												</p>
											</div>
										</div>
										<div className='discount-box'>
											<div className='discount-box-content'>
												<h3 className='desconto-economize'>35%</h3>
												<p className='text-economize'>
													de desconto em medicamentos genéricos isentos de
													prescrição
												</p>
											</div>
										</div>
										<div className='discount-box'>
											<div className='discount-box-content'>
												<h3 className='desconto-economize'>
													<small>Até</small> 25%
												</h3>
												<p className='text-economize'>
													de desconto em medicamentos
													<br />
													de marca
												</p>
											</div>
										</div>
										<div className='discount-box'>
											<div className='discount-box-content'>
												<h3 className='desconto-economize'>5%</h3>
												<p className='text-economize'>
													de desconto no
													<br />
													setor de perfumaria{' '}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div> */}
							{/* Fim Slider */}
							<section className='section discounts sec-high'>
								<div className='container-fluid'>
									<div className='discounts-holder'>
										<h3 className='f-bold'>Clube de Descontos</h3>
										<div className='discounts-carousel'>
											<div className='discounts-item'>
												<div className='discounts-item--inner'>
													<Cinema></Cinema>
													<h3>
														<strong className='f-bold'>Cinemas</strong> até{' '}
														<strong className='f-bold'>50%</strong>
													</h3>
												</div>
											</div>
											<div className='discounts-item'>
												<div className='discounts-item--inner'>
													<Eletrodomesticos></Eletrodomesticos>
													<h3>
														<strong className='f-bold'>Eletrodomésticos</strong>{' '}
														até <strong className='f-bold'>50%</strong>
													</h3>
												</div>
											</div>
											<div className='discounts-item'>
												<div className='discounts-item--inner'>
													<Cursos></Cursos>
													<h3 id='mais-economia'>
														<strong className='f-bold'>Cursos</strong> até{' '}
														<strong className='f-bold'>30%</strong>
													</h3>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section className='admvida'>
								<ProductTable
									benefits={benefitsIndividual}
									benefitsTable={benefitsTableIndividual}
									plansYalo={plansIndividual}
									benefitsTips={benefitsTipsIndividual}
									loja='brasiladmindividual'
									planPrice={planPrice}
								/>
							</section>
							{/* <section className='section-diferenca-corona'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-md-12'>
											<h2 className='f-black' id='mais-saude'>
												Com você, no momento que mais precisa
											</h2>
											<h3 className='f-black'>
												Estamos aqui para te ajudar durante o coronavírus
											</h3>
										</div>
									</div>
									<div className='row'>
										<div className='col-12 col-md-10'>
											<ul>
												<li>
													<p className='f-regular'>
														Todas as consultas <strong>online</strong> por{' '}
														<strong>R$40</strong> para seu acompanhamento
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Seja atendido de{' '}
														<strong>qualquer lugar do Brasil</strong>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Sua prescrição médica disponível no{' '}
														<strong>aplicativo</strong> do{' '}
														<span>dr.consulta</span>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Atendimento especial para{' '}
														<strong>dúvidas sobre o coronavírus</strong>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														<strong>Psicologia</strong> e{' '}
														<strong>psiquiatria</strong> para acompanhamento
														durante período de quarentena
													</p>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</section> */}
							{/* <section className='yalo-saude'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-12 col-md-8 padding-top300'></div>
										<div className='col-12 col-md-4 center-mobile-price '>
											<h2>
												Yalo saúde <br /> <span>por apenas</span>
											</h2>
											<h3 id='mais-economia'>
												<span>12x</span>53
												<strong className='price-cents'>,20</strong>
											</h3>
											<h4>
												e garanta mais
												<br />
												saúde para
												<br />a sua vida.
											</h4>
											<a href='/loja/beneficiario' className='btn btn-orange'>
												Assine agora
											</a>
										</div>
									</div>
								</div>
							</section>{' '}
							*/}
							{/* Modal Corona Vírus */}
							<section className='diferenca-new brasilvida'>
								<div className='container-fluid'>
									<div className='row text-center'>
										<div className='col-12'>
											<h2 className='f-black'>
												Economize em mais de 2.000 farmácias
											</h2>
										</div>
									</div>

									<div className='row text-center'>
										<div className='col-12'>
											<h3 className='desconto-economize-new brasilvida'>15%</h3>
											<p className='text-economize-new brasilvida'>
												de desconto em medicamentos tarjados,
												<br />
												genéricos e de marca.
											</p>
										</div>
									</div>
									<div className='row text-center'>
										<div className='col-12'>
											<img
												src={farmacias2}
												className='img-new brasilvida'
												alt=''
											/>
										</div>
									</div>
								</div>
							</section>
							<footer className='footer visible-md visible-lg'>
								<div className='visible-md visible-lg last-message'></div>
							</footer>
						</div>
					</div>
				</div>
				{/* <WhatsAppBtn
					phone='+5511983120317'
					message='Olá,+estou+entrando+em+contato+através+do+site+Yalo'
				/> */}

				{/* <Link
					to='/loja/yalo/beneficiario?assinatura=saude'
					className='f-bold button-sticky hidden-lg mobile-sign'>
					Assinar agora!
				</Link> */}
			</div>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign }, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home2);
